import styled from "styled-components";
import { CustomModalContainer, Paragraph2, WrapperContainer } from "../../../../components";
import { DateInputContainer } from "../../../../components/DateInput/styled";
import { TimeInputContainer } from "../../../../components/TimeInput/styled";
import { ModalContent } from "../../../../components/Modal/styled";

export const SectionTitle = styled(Paragraph2)`
  font-weight: 600;
`;

export const InputSectionWrapper = styled(WrapperContainer)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;

  ${DateInputContainer}, ${TimeInputContainer} {
    max-width: 100%;

    .react-datepicker-wrapper {
      width: 100%;
    }
  }
`;

export const FWUModalContainer = styled(CustomModalContainer)`
  ${ModalContent} {
    max-height: 95vh;
    min-height: min(770px, 95vh);
  }

  height: unset;
  min-height: 75%;
`;
